import { PATHS, URL_PARAMS } from '../constants';

interface GetWorkDetailPathInput {
    /**
     * True if the user deleted this audio file
     */
    audioDeleted: boolean;
    /**
     * The search params portion of the URL, like '?foo=bar&fizz=buzz'
     */
    search?: string;
    /**
     * The current trqkSong ID, if any
     */
    trqkSongId?: Maybe<string>;
    /**
     * The current trqkAudio ID, if any
     */
    trqkAudioId?: Maybe<string>;
}

/**
 * Get the href path for a WorkDetail page, which includes a URL parameter for either or both the
 * `trqkAudioId` and `trqkSongId`.
 * @param input - see {@link GetWorkDetailPathInput}
 */
export const getWorkDetailPath = ({
    audioDeleted,
    search,
    trqkAudioId,
    trqkSongId,
}: GetWorkDetailPathInput): string | null => {
    if ((audioDeleted || !trqkAudioId) && !trqkSongId) {
        return null;
    }

    const searchParams = new URLSearchParams(search);

    if (trqkSongId) {
        searchParams.set(URL_PARAMS.SONG_ID, encodeURIComponent(trqkSongId));
    }

    if (!audioDeleted && trqkAudioId) {
        searchParams.set(URL_PARAMS.AUDIO_ID, encodeURIComponent(trqkAudioId));
    }

    return `${PATHS.DETAIL}?${searchParams.toString()}`;
};
